import type { StageMove } from "@shared/recordSummary";
import { ProspectStepper } from "@/components/prospects/ProspectStepper";
import { NurtureBanner } from "@/components/prospects/NurtureBanner";
import { RecordPanel } from "@/components/record/RecordFrame";
import { stageMoveLine } from "@/components/record/facts/companyFacts";
import { localYmd } from "@/components/record/recordFormat";

/** The five milestones (or the nurture banner while parked), then when and why the stage last moved. */
export function StageTrackPanel({ stage, parked, revisitOn, holdReason, moves, onStage, onConvert, onPark, onResume, resuming }: {
  stage: string | null; parked: boolean; revisitOn: string | null; holdReason: string | null;
  moves: StageMove[] | undefined; onStage: (s: string) => void; onConvert: () => void;
  onPark: () => void; onResume: () => void; resuming: boolean;
}) {
  const today = localYmd(new Date());
  const lines = (moves ?? []).slice(0, 5).map((m) => stageMoveLine(m, today));
  return (
    <RecordPanel title="Stage">
      {parked ? (
        <NurtureBanner revisitOn={revisitOn} reason={holdReason} onResume={onResume} pending={resuming} />
      ) : (
        <>
          <ProspectStepper stage={stage} onSelect={onStage} onConvert={onConvert} />
          <button type="button" onClick={onPark} className="mt-1.5 text-xs text-muted-foreground underline decoration-dashed hover:text-foreground">
            Park in nurture · pick a revisit date
          </button>
        </>
      )}
      {lines.length > 0 && (
        <ol className="mt-3 grid gap-1 border-t pt-2.5">
          {lines.map((l, i) => (
            <li key={i} className="grid grid-cols-[64px_minmax(0,1fr)] gap-2 text-[12.5px]">
              <span className="tabular-nums text-muted-foreground">{l.when}</span>
              <span>
                <span className="font-semibold">{l.text}</span>
                {l.detail && <span className="text-muted-foreground"> · {l.detail}</span>}
              </span>
            </li>
          ))}
        </ol>
      )}
    </RecordPanel>
  );
}
